import { render } from "./SlideWelcome.vue?vue&type=template&id=95598aa0&scoped=true"
import script from "./SlideWelcome.vue?vue&type=script&lang=js"
export * from "./SlideWelcome.vue?vue&type=script&lang=js"

import "./SlideWelcome.vue?vue&type=style&index=0&id=95598aa0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95598aa0"]])

export default __exports__